import React, { FunctionComponent, useState } from 'react'
import { Button, Layout } from 'antd'
import AdminMenu from './AdminMenu/AdminMenu'
import { MenuOutlined } from '@ant-design/icons'
import { atText } from '../../../assets/logos'

const { Sider } = Layout

const AdminSider: FunctionComponent<any> = () => {
  const [collapsed, setCollapsed] = useState<boolean>(true)

  return (
    <Sider collapsed={collapsed} width={300}>
      <div
        id={'menu-logo'}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: collapsed ? 'center' : 'space-evenly',
          alignItems: 'center',
          padding: '10px'
        }}
      >
        {collapsed ? null : (
          atText({ width: '200px' })
        )}
        <Button size={'large'} icon={<MenuOutlined />} onClick={() => setCollapsed(!collapsed)} />
      </div>
      <AdminMenu collapsed={collapsed} />

    </Sider>
  )
}

export default AdminSider
